import { Site } from '../models';
import { isNotUndefinedNorNull } from './common.helper';

export const mapState = (storeDetail?: Site): string => {
	if (!storeDetail) {
		return 'Invalid State';
	}

	switch (storeDetail.state) {
		case 'AUK':
			return 'Auckland';
		case 'BOP':
			return 'Bay of Plenty';
		case 'CAN':
			return 'Canterbury';
		case 'GIS':
			return 'Gisborne';
		case 'HKB':
			return `Hawke's Bay`;
		case 'MBH':
			return 'Marlborough';
		case 'MWT':
			return 'Manawatu-Wanganui';
		case 'NSN':
			return 'Nelson';
		case 'NTL':
			return 'Northland';
		case 'OTA':
			return 'Otago';
		case 'STL':
			return 'Southland';
		case 'TAS':
			return 'Tasman';
		case 'TKI':
			return 'Taranaki';
		case 'WKO':
			return 'Waikato';
		case 'WGN':
			return 'Wellington';
		case 'WTC':
			return 'West Coast';
		case 'CIT':
			return 'Chatham Islands Territory';

		default:
			return 'Invalid State';
	}
};

export const getStreet = (storeDetail?: Site): string => {
	if (!storeDetail) {
		return '';
	}

	let combinedStreet = '';

	if (isNotUndefinedNorNull(storeDetail?.addressLine1)) {
		combinedStreet += storeDetail.addressLine1;
	}

	if (isNotUndefinedNorNull(storeDetail?.addressLine2)) {
		if (isNotUndefinedNorNull(combinedStreet)) {
			combinedStreet += ', ';
		}

		combinedStreet += storeDetail.addressLine2;
	}

	return combinedStreet;
};
